import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Healthcs2 = () => {
     useEffect(() => {
                window.scrollTo(0, 0); // Scroll to top when component loads
              },[]);
  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/healthcsimg2.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  marginTop:"-200px", fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Accelerating automation for a global automotive components supplier
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      {/* Business Needs Section */}
           <Container sx={{ py: 10 }}>
           <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
           For the Community Health Plan of Washington (CHPW), a claims backlog undermined the trust of both service providers and members.
               </Typography>
           <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
           CHPW overhauled its processes to pay claims faster and more accurately, accelerating provider cash flows to better ensure their network allegiance as well as the high quality of their member services.
               </Typography>
             <Typography variant="h4" fontWeight="bold" mb={3}>
               Business Needs
             </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
             U.S. healthcare plans that serve lower-income Medicaid patients typically offer lower reimbursement rates for service providers than commercial insurers. That can make it hard to contract with doctors and other medical professionals. Despite this, many medical groups accept Medicaid patients to give back to their communities. But this altruism can become strained if the payments are late or inaccurate. </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
             Such was the case years ago, when the Community Health Plan of Washington (CHPW) faced both those problems. That changed with assistance from the Tech Informatic Solutions Services Consulting and Business Process Outsourcing teams. </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
             Today, CHPW enjoys a solid reputation as one of the best Medicaid payers in Washington State and regulators often seek advice from them when they plan to modify existing guidelines and regulations or roll out new ones.</Typography>
     
     
     
              {/* outcome Section */}
            <Typography variant="h4" fontWeight="bold" mb={-12}>
              Outcomes
             </Typography>
            
           </Container>
           <Container maxWidth="lg">
             <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
               {[
                 {
                   bgImage: "/image/f3.jpeg", // Replace with actual image path
                   points: [
                     "Reduces claims backlog to < 2.5 days",
                     "Boosts competitive positioning",
                     "Provides scalability for growth"
                   ],
                 },
                 {
                   bgImage: "/image/f2.jpeg", // Replace with actual image path
                   points: [
                     "Enhances member and provider satisfaction",
                     "Strengthens brand reputation",
                   ],
                 },
               ].map((feature, index) => (
                 <Grid item xs={12} md={6} key={index}>
                   <motion.div
                     whileHover={{ y: -5 }} // Jump effect on hover
                     transition={{ type: "spring", stiffness: 200, damping: 10 }}
                   >
                      <Box
                       sx={{
                         position: "relative",
                         backgroundImage: `url(${feature.bgImage})`,
                         backgroundSize: "cover",
                         backgroundPosition: "center",
                         borderRadius: "12px",
                         p: 4,
                         minHeight: "250px",
                         display: "flex",
                         flexDirection: "column",
                         justifyContent: "space-between", // ✅ Ensures equal spacing
                         overflow: "hidden",
                         textAlign: "left", // ✅ Left-aligned text
                       }}
                     >
                       {/* Dark Overlay for Better Visibility */}
                       <Box
                         sx={{
                           position: "absolute",
                           top: 0,
                           left: 0,
                           width: "100%",
                           height: "100%",
                           backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                           zIndex: 1,
                         }}
                       />
     
                       {/* Bullet Points - Always Visible */}
                       <Box
                         sx={{
                           position: "relative",
                           zIndex: 2,
                           display: "flex",
                           flexDirection: "column",
                           gap: "30px", // ✅ Creates space between two bullet points
                           minHeight: "100%", // ✅ Ensures equal height
                           mt:6,
                         }}
                       >
                         {feature.points.map((point, i) => (
                           <Box
                             key={i}
                             sx={{
                               display: "flex",
                               alignItems: "flex-start", // ✅ Aligns bullet with text properly
                               gap: "8px",
                               color: "white",
                               minHeight: "50px", // ✅ Ensures each bullet aligns properly
                             }}
                           >
                             <Typography
                               component="span"
                               sx={{
                                 fontSize: "1.5rem",
                                 lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                               }}
                             >
                               ✅
                             </Typography>
                             <Typography
                               variant="body1"
                               sx={{
                                 fontSize: { xs: "1rem", md: "1.2rem" },
                                 lineHeight: "1.5rem", // ✅ Ensures text stays in line
                               }}
                             >
                               {point}
                             </Typography>
                           </Box>
                         ))}
                       </Box>
                     </Box>
                   </motion.div>
                 </Grid>
               ))}
             </Grid>
           </Container>
     
     
           <Container sx={{ py: 10 }}>
           
            
           <Typography  variant="h4" fontWeight="bold" mb={3}>
           Solution
               </Typography>
               <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
               To serve approximately 270,000 members, CHPW supports a network of 20 community health centers that operate more than 130 clinics across the state. Its network consists of over 2,500 primary care and 14,000 specialists as well as more than 100 hospitals. As a not-for-profit enterprise who believes in the power of community, it invests all its excess profits back into the health centers, so they can continue delivering high-quality care to anyone who walks through their doors. </Typography>
             <Typography variant="h5" fontWeight="bold" mb={3}>
             Keeping providers and members satisfied
             </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
             According to Alan Lederman, CHPW’s chief operating officer, CHPW provides a safety net for the state’s underserved and low-income communities. “We have to be efficient, effective and timely in paying our providers, because we can't pay them top dollar for care and coverage. We also must be easy to work with because their time is so valuable. Both providers and members have other options, so our speed, accuracy and excellent customer service are what set us apart.”</Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
             Before engaging Tech Informatic Solutions Services, CHPW had organizational ties with a third party that managed its claims and payments. “Problems arose because it was hard for CHPW to access all its data and system maintenance was slow and inefficient,” Lederman says. </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
             To remedy the situation, CHPW outsourced the work to Tech Informatic Solutions Services to provide a software-as-a-service (SaaS) platform and claims processing. Tech Informatic Solutions Services also manages data entry, mailroom services, claims processing and configuration services as part of its Business Process Outsourcing solution. CHPW uses Tech Informatic Solutions Services proprietary tools which populate content into new provider and member portals as well as captures and processes claims, streamlining workflow. Both solutions are an integral part of a new Digital BPaaS for Health Plans solution.</Typography>
     
             <Typography variant="h5" fontWeight="bold" mb={3}>
             Paying providers faster and more accurately
             </Typography>
      <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
      Today, CHPW’s claims payment system is among the nation’s most efficient. “We have about two and a half days of claims on hand, which I would put up against any plan nationwide, commercial or otherwise, in terms of consistency and accuracy of that inventory,” Lederman says.  </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
             Lederman notes that two key concerns of all healthcare service providers are getting paid quickly and accurately. “This helps set us apart from other plans that doctors and allied medical services could engage. In both categories, CHPW excels with the help of its Tech Informatic Solutions Services claims payment system." 
             </Typography>
            
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
             For example: Over the most recent three-year period, CHPW’s payment accuracy has exceeded the 99 percent service level agreement (SLA), with a 99.47 percent financial accuracy average.  </Typography>
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
             He adds, “When I compare what we were paying our previous vendors for the services to what we pay Tech Informatic Solutions Services today, we've literally saved millions of dollars. This has enabled us to reduce our overall administrative expense load so much that we have one of the lowest, if not the lowest, Medicaid administration rates in the state. This allows us to generate more capital that we can then reinvest in the local community through our member health centers.”</Typography>
                   
             
             <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
             More recently, CHPW engaged Tech Informatic Solutions Services to build a new network provider directory. Before, CHPW had completely outsourced that application, including updates to a participating provider’s information. “Because they were using old technology, we couldn’t make changes ourselves,” Lederman says. “Work orders were required and changes could take weeks to get done.”   </Typography>
     
     
            
     
     
             
     </Container>


<Footer/>
    </Box>


  );
};

export default Healthcs2;
